import RegistrationSuccess from './registrationSuccess/RegistrationSuccess';

export default RegistrationSuccess;
